import { useQuery } from '@tanstack/react-query';
import getUserPreferences from '@core/api/getUserPreference';
import useAuthReady from './useAuthReady';

export const QUERY_KEY = 'USER_PREFERENCES';

const useGetUserPreferences = () => {
  const { isOrgReady } = useAuthReady();

  const { data: userPreferences, ...rest } = useQuery({
    queryFn: () => getUserPreferences(),
    queryKey: [QUERY_KEY],
    // Organization-scoped: this endpoint needs the product token, not just the
    // API one. Firing it at mount is what ThemeProvider's forced refetch used
    // to compensate for.
    enabled: isOrgReady,
    staleTime: 1000 * 60 * 60 * 12,
    gcTime: 1000 * 60 * 60 * 12.5,
    retry: false,
  });

  return { userPreferences, ...rest };
};

export default useGetUserPreferences;
